/* Herreværket · lille hjælper til hv-sektionerne. Ingen afhængigheder. */
(function () {
  'use strict';
  var root = document.documentElement;
  var design = window.Shopify && window.Shopify.designMode;

  /* Scroll-reveal. Klassen sættes kun når JS kører, så indhold altid er synligt uden JS. */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.hv-rv:not(.is-in)');
    if (!els.length) return;
    if (design || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Marquee: dupliker sporet så loopet er sømløst, uanset skærmbredde. */
  function initMarquee(scope) {
    (scope || document).querySelectorAll('[data-hv-marquee]').forEach(function (track) {
      if (track.dataset.ready) return;
      var group = track.querySelector('.hv-mq__group');
      if (!group) return;
      var w = group.getBoundingClientRect().width || 1;
      var need = Math.max(2, Math.ceil((window.innerWidth * 2) / w));
      var have = track.querySelectorAll('.hv-mq__group').length;
      for (var i = have; i < need; i++) {
        var c = group.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      }
      track.style.setProperty('--hv-mq-dist', '-' + w + 'px');
      track.dataset.ready = '1';
    });
  }

  /* Announcement: roterende beskeder (ambient, ingen pause på hover). */
  function initRotator(scope) {
    (scope || document).querySelectorAll('[data-hv-rotate]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var items = wrap.querySelectorAll('.hv-ann__msg');
      if (items.length < 2) return;
      var i = 0, ms = parseInt(wrap.getAttribute('data-hv-rotate'), 10) || 4500;
      setInterval(function () {
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, ms);
    });
  }

  /* Links til #pakker på sider uden pakkesektion (fx produktsiden) scroller op til købsboksen. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#pakker"], a[href="#MainContent"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (id === 'pakker' && document.getElementById('pakker')) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  function boot(scope) { window.__hvBoot = true; initReveal(scope); initMarquee(scope); initRotator(scope); }

  root.classList.add('hv-js');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();